import React, { useCallback, useMemo } from 'react'
import { deleteCookie, inIframe, useEffectOnce } from '@chilecompra/react-kit'
import { Button, useViewport } from '@chilecompra/react-kit/components'
import { REACT_APP_CAPTCHA_ENABLED, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import NotFoundPage from './NotFound'
import AuthorizationContext from '../containers/AuthorizationProvider/AuthorizationProvider.context'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import HeaderContainer from '../containers/Header/Header.container'
import HeadingSectionContainer from '../containers/HeadingSection/HeadingSection.container'
import PublicFooterContainer from '../containers/Footer/PublicFooter.container'
import SearchFilterSectionContainer from '../containers/SearchFilterSection/SearchFilterSection.container'
import SearchBuyerContainer from '../containers/SearchBuyer/SearchBuyer.container'
import SearchSellerSection from '../containers/SearchSellerSection/SearchSellerSection.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import { Column, Row } from './SearchBuyer.styles'
import { initializeRecaptcha } from '../modules/hooks/recaptcha'

/**
 * The SearchBuyer' page.
 */
const SearchBuyer = () => {
  const { size } = useViewport()
  const breadcrumbs = useCallback(isPrivate => {
    return [
      {
        children: !isPrivate ? 'Inicio' : 'Escritorio',
        to: !isPrivate
          ? `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`
          : `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
        type: 'external',
        variant: 'link',
        onClick: event => handleClickHome(event, isPrivate)
      },
      {
        children: 'Búsqueda Comprador',
        variant: 'text'
      }
    ]
  }, [])

  const title = 'Búsqueda de compradores'
  const subtitle =
    'Accede a la ficha con el detalle de la información de cada uno de los organismos compradores inscritos en Mercado Público.'

  const handleClickHome = (event, isPrivate) => {
    event.preventDefault()
    deleteCookie('access_token')
    if (isPrivate) {
      window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
      return
    }
    location.href = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Home`
  }

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  useEffectOnce(() => {
    if (REACT_APP_CAPTCHA_ENABLED === true || REACT_APP_CAPTCHA_ENABLED === 'true') {
      initializeRecaptcha()
    }
    if (isInIframe) {
      window.parent.postMessage(
        {
          action: 'scrollTo',
          value: {
            x: 0,
            y: 0
          }
        },
        REACT_APP_MERCADO_PUBLICO_BASE_URL
      )
    } else {
      window.scrollTo(0, 0)
    }
  })

  return (
    <ProtectByFeatures rule={features => features['com.buyer/search.engine']} fallback={() => <NotFoundPage />}>
      <AuthorizationProviderContainer>
        <AuthorizationContext.Consumer>
          {({ isPrivated }) => {
            return (
              <ProtectByAccessToken fallback={() => <NotFoundPage />}>
                <BrandLayout
                  featured={
                    <HeadingSectionContainer
                      breadcrumbs={breadcrumbs(isPrivated && isInIframe)}
                      title={title}
                      subtitle={subtitle}
                    />
                  }
                  header={!(isPrivated && isInIframe) && <HeaderContainer />}
                  footer={!(isPrivated && isInIframe) && <PublicFooterContainer />}
                >
                  <Row margin="0">
                    <Column xs={12} md={8} padding="0">
                      <SearchFilterSectionContainer />
                    </Column>
                    {!(isPrivated && isInIframe) && (
                      <Column xs={12} md={4} padding="0">
                        <SearchSellerSection />
                      </Column>
                    )}
                    <Column xs={12} md={8} padding="0">
                      <SearchBuyerContainer />
                    </Column>
                  </Row>
                  <Row margin={size.isUpToMedium ? '80px 0' : '20px 0'}>
                    <Column padding="0">
                      <Button
                        color="default"
                        variant="outlined"
                        onClick={event => handleClickHome(event, isPrivated && isInIframe)}
                      >
                        Volver
                      </Button>
                    </Column>
                  </Row>
                </BrandLayout>
              </ProtectByAccessToken>
            )
          }}
        </AuthorizationContext.Consumer>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}

export default SearchBuyer
